/**
 * 积分显示：整数不带小数点，有小数时最多 2 位小数。
 *
 * ⚠️ 必须与后端 `PointKit.fmt()` **保持同一口径**（换成别的写法就会出现
 * 「后端算 2.5、前端显示 2.50」这种不一致）。
 * 例：2 → "2"，2.5 → "2.5"，2.50 → "2.5"，-0.25 → "-0.25"。
 *
 * 用法：模板里直接 `{{ $fmtPoints(row.points) }}`（已在 main.js 挂到 Vue.prototype），
 * 需要在 JS 里拼字符串时从这里 import。
 */
export function fmtPoints(v) {
  if (v === null || v === undefined || v === '') return '0'
  const n = Number(v)
  if (!isFinite(n)) return '0'
  return String(Math.round(n * 100) / 100)
}
